import { Component, Input } from '@angular/core';
import { isString } from 'lodash-es';
import { isArray } from 'lodash-es';
import { isEmpty } from 'lodash-es';

@Component({
  selector: 'app-success-notification',
  template: `
  <div *ngIf="messages && messages.length" data-test-id="successNotif">
  <div class="notif notif--small notif--green vert-0050" *ngFor="let messages of messages">
        <span>{{messages}}</span>
    </div>
  </div>
  `,
})

export class SuccessNotificationComponent {
  private _messages: Array<string> = [];
  constructor() { }
  /**
   * 'errors' is expected to be an input of either a string or an array of strings
   */
  @Input() set messages(messages: Array<string> | any) {
    // Caller just passed in a string instead of an array of strings
    if (isEmpty(messages)) {
      this._messages = [];
    }

    if (isString(messages)) {
      this._messages = [messages];
      return;
    }
    // Caller passed in array, assuming it is a string array
    if (isArray(messages)) {
      this._messages = messages;
      return;
    }
    // At this point just set it to whatever might have been passed in and let
    // the user debug when it is broken.
    this._messages = messages;
  }

  get messages() {
    return this._messages;
  }
}
